import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-purity-of-2-hydroxyethyl-methacrylate',
  templateUrl: './purity-of-2-hydroxyethyl-methacrylate.component.html',
  styleUrls: ['./purity-of-2-hydroxyethyl-methacrylate.component.scss']
})
export class PurityOf2HydroxyethylMethacrylateComponent implements OnInit {
  @ViewChild('purityOf2HydroxyethylMethacrylateInput') purityOf2HydroxyethylMethacrylateInput!: ElementRef;
  purityOf2HydroxyethylMethacrylate!: string;

  constructor(private formService: FormService) {}
  
  ngOnInit(): void {
    this.purityOf2HydroxyethylMethacrylate = this.currentForm.get('purityOf2HydroxyethylMethacrylate')?.value;
  }

  public clearPurityOf2HydroxyethylMethacrylateInputField() {
    this.purityOf2HydroxyethylMethacrylate = '';
    this.currentForm.patchValue({'purityOf2HydroxyethylMethacrylate': ''});
  }

  public updatePurityOf2HydroxyethylMethacrylate(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.purityOf2HydroxyethylMethacrylate = '';
      }
    }
    this.currentForm.patchValue({'purityOf2HydroxyethylMethacrylate': this.purityOf2HydroxyethylMethacrylate});
  }

  public cancelUpdate() {
    this.purityOf2HydroxyethylMethacrylate = this.currentForm.get('purityOf2HydroxyethylMethacrylate')?.value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
